<template>
  <section style="display: inherit">
    <a
      v-if="buttonType == 'icon'"
      @click="fnShowModal()"
      v-b-tooltip.hover
      title="Create / View message"
    >
      <span><i class="las la-paper-plane text-primary fs-1100"></i></span>
    </a>

    <button
      v-if="buttonType == 'button'"
      class="btn btn-primary btn-sm"
      @click="fnShowModal()"
      v-b-tooltip.hover
      title="Create / View message"
    >
      Notes
    </button>

    <b-modal ref="userModal" size="lg" hide-footer title="Notes">
      <div class="d-block p-3">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12">
            <div class="form-group">
              <label class="" for="note">Note</label>
              <vue-editor v-model="body" :editor-toolbar="customToolbar" />
              <div class="invalid-feedback" v-if="errors.msgBody">
                {{ errors.msgBody[0] }}
              </div>
            </div>
          </div>

          <div class="col-12 text-right">
            <button
              type="button"
              class="btn btn-dark btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button
              type="button"
              @click="fnAddNotes()"
              class="btn btn-primary btn-sm"
            >
              <b-spinner small v-if="loading" class="mr-2"></b-spinner>
              Send
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>
  <script>
import * as messageService from '../../../services/message.service'
import * as maturingLeasService from '../../../services/maturingLeas.service'
import * as authService from '../../../services/auth.service'
import { getCurrentDate } from '../../../services/sharedFn.service'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ModalNoteAddMaturingLeases',
  props: {
    quoteId: {
      type: Number,
      required: true
    },
    buttonType: {
      type: String,
      default: 'icon'
    }
  },
  data() {
    return {
      loginUser: {},
      errors: {},
      loading: false,
      body: '',
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        ['blockquote', 'code-block'],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }]
      ]
    }
  },
  computed: {
    ...mapGetters(['getMaturingLeasPaginateData', 'getMaturingLeasPaginate'])
  },
  methods: {
    ...mapActions(['fetchMaturingLeasPaginate']),
    fnShowModal() {
      this.showModal()
    },
    hideModal() {
      this.$refs.userModal.hide()
    },
    showModal() {
      this.$refs.userModal.show()
    },
    fnAddNotes: async function () {
      const { firstName } = this.loginUser

      this.errors = ''
      let obj = {
        content: {
          note: this.body,
          date_add: getCurrentDate('YYYY-MM-DD'),
          add_by: firstName
        },
        status: 1
      }
      try {
        this.loading = true
        const res = await maturingLeasService.addNote(this.quoteId, obj)

        if (res.status == 200) {
          this.hideModal()

          this.fetchMaturingLeasPaginate(this.getMaturingLeasPaginate)

          messageService.fnSweetAlertSuccessToast(
            'New note',
            'Add successfully'
          )

          this.body = ''
        }
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'New note',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast('New note', 'Something wrong')
            break
        }
      }

      this.loading = false
    }
  },
  created() {
    this.loginUser = authService.getUserFromToken()
  }
}
</script>